<template>
  <div class="top25">
    <div v-if="pollManage === undefined">
      <h1>VOTAÇÃO NÃO ENCONTRADA</h1>
    </div>

    <div v-else-if="pollManage !== undefined">
      <v-card-title class="titledados">Sobre:</v-card-title>
      <v-card-text class="textdados">
        <v-sheet v-html="pollManage.description" />
      </v-card-text>

      <v-row>
        <v-col>
          <v-card-title class="titledados">Data de Publicação:</v-card-title>
          <v-card-text class="textdados">{{ formatDate( pollManage.publicationDate ) }}</v-card-text>
        </v-col>

        <v-col v-if="pollManage.pageType !== 'VOTING_SHOWCASE'">
          <v-card-title class="titledados">Inicio da votação:</v-card-title>
          <v-card-text v-if="pollManage.deadlineForVotingOnProjects !== undefined">
            {{ formatDate( pollManage.deadlineForVotingOnProjects.from ) }}
          </v-card-text>
        </v-col>

        <v-col v-if="pollManage.pageType !== 'VOTING_SHOWCASE'">
          <v-card-title class="titledados">Encerramento da votação:</v-card-title>
          <v-card-text v-if="pollManage.deadlineForVotingOnProjects !== undefined">
            {{ formatDate( pollManage.deadlineForVotingOnProjects.to ) }}
          </v-card-text>
        </v-col>
      </v-row>

      <v-card-title class="titledados">Dados selecionados para serem mostrados nos cards de projetos:</v-card-title>
      <v-row v-if="pollManage.projectDataForDisplay !== undefined">
        <ul class="selecionadoslista">
          <div v-for="(item, index) in pollManage.projectDataForDisplay" :key="index" >
           <li v-if="index[0]!=='_' && item && typeof item != 'object'">{{  $t(index) }}</li>
           <li v-if="index[0]!=='_' && item && typeof item == 'object' && item.length > 0">{{  $t(index) }}</li>
          </div>
        </ul>
      </v-row>

      <v-row v-if="pollManage.pageType !== 'VOTING_SHOWCASE'">
        <v-col>
          <v-card-title class="titledados">Privacidade da pontuação:</v-card-title>
          <v-card-text class="textdados">{{ (pollManage.scoreAsPrivate) ? 'Sim' : 'Não'}}</v-card-text>
        </v-col>

        <v-col>
          <v-card-title class="titledados">Quantidade de votos recebidos:</v-card-title>
          <v-card-text class="textdados">{{ pollManage.voteLimitPerEmail ? pollManage.voteLimitPerEmail : 0 }}</v-card-text>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import {
    getBRDateTime
  } from '@/utils/DateUtils';

  export default {
    name: 'PollManageData',
    props: [],
    computed: {
      ...mapState(["pollManage"]),
    },
    data: () => ({}),
    mounted() {

    },
    methods: {
      formatDate(dateStr) {
        return getBRDateTime(dateStr);
      }
    },
  }

</script>

<style scoped>
  .top25 {
    margin-top: 25px;
  }

  .titledados {
    color: #415b64;
    letter-spacing: 0;
    opacity: 1;
    font-weight: 400;
    font-size: 24px;
    padding: 0 0 0 16px;
  }

  .textdados {
    margin: 0 0 10px;
    color: #323232;
    opacity: 1;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
  }

  ul.selecionadoslista {
    padding-left: 60px;
    width: 100%;
  }

  ul.selecionadoslista li {
    float: left;
    width: 20%;
    font-size: 14px;
    line-height: 28px;
    min-width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/components/poll/manage/Data.vue